var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dd-spinner",style:(_vm.styleVars),attrs:{"aria-label":"loading","role":"status"}})}
var staticRenderFns = []

export { render, staticRenderFns }